/** Motivos del Historial de partidos en español (Eduardo 2026-09-18): el
 * backend guarda códigos técnicos ("schedule_change:Lluvia",
 * "team_tie_resolved:2-1"); aquí se traducen para el organizador. Un texto
 * libre que escribió el admin (posponer/cancelar con motivo) pasa tal cual. */

const REASON_LABELS: Record<string, string> = {
  status_update: "Cambio de estatus",
  bulk_program: "Programación masiva",
  bulk_unschedule: "Desprogramación masiva",
  unschedule_single: "Partido desprogramado",
  // Publicar horarios (Eduardo 2026-10-01).
  schedule_published: "Los jugadores ya ven su horario",
  schedule_unpublished: "Quedó sin horario",
  schedule_unpublished_manual: "Horario despublicado (vuelve a borrador)",
  round_robin_generated: "Round Robin generado",
  round_robin_jornada_assigned: "Jornada asignada",
  // Acomodar la hoja del Round Robin (Eduardo 2026-10-01).
  rr_order_changed: "Orden del grupo cambiado",
  rr_group_change: "Cambio de grupo",
  round_robin_playoffs_generated: "Playoffs generados",
  round_robin_phase_playoffs_generated: "Playoffs generados",
  round_robin_playoff_winners_assigned: "Ganadores de playoffs asignados",
  round_robin_playoff_legacy_bracket_reconstructed: "Cuadro de playoffs reconstruido",
  round_robin_playoffs_auto_removed: "Playoffs retirados solos (se despublicó un resultado de grupos)",
  round_robin_playoffs_auto_reseeded: "Playoffs re-sembrados solos (cambió la clasificación)",
  rr_playoff_prelim_auto_advanced: "El ganador de la preliminar avanzó solo",
  elimination_bracket_generated: "Cuadro generado",
  elimination_bracket_regenerated: "Cuadro regenerado",
  elimination_skeleton_materialized: "Rondas futuras del cuadro creadas",
  elimination_next_round_generated: "Siguiente ronda generada",
  elimination_next_round_filled: "Siguiente ronda llenada",
  elimination_auto_advanced: "El ganador avanzó solo en el cuadro",
  elimination_auto_retracted: "El avance del cuadro se regresó (resultado despublicado)",
  team_line_lineup: "Alineación de la línea",
  team_update: "Pareja actualizada",
  team_enrollment: "Pareja inscrita",
  team_deleted: "Pareja eliminada",
  converted_to_doubles_team: "Convertido a pareja",
  enrollment: "Inscripción",
  public_registration: "Inscripción por el link público",
  public_registration_revive: "Inscripción reactivada por el link público",
  registration_deleted: "Registro eliminado",
  admin_charge_revive: "Cobro reactivado",
  admin_charge_recharge: "Cobro re-emitido",
  charge_cancelled: "Cobro cancelado",
  delete_tournament: "Torneo eliminado",
  superadmin_delete_tournament: "Torneo eliminado por gobierno",
};

/** Códigos con motivo pegado ("bulk_unschedule:Lluvia"): etiqueta base. */
const REASON_WITH_DETAIL: Array<[string, string]> = [
  ["schedule_change:", "Cambio de horario"],
  // Un horario ya publicado que se quitó: sus jugadores recibieron el aviso.
  ["schedule_unpublished_manual:", "Horario despublicado (vuelve a borrador)"],
  ["schedule_unpublished:", "Quedó sin horario"],
  ["bulk_unschedule:", "Desprogramación masiva"],
  ["unschedule_single:", "Partido desprogramado"],
];

export function historyReasonLabel(reason: string | null | undefined): string | null {
  const raw = (reason ?? "").trim();
  if (!raw) return null;
  for (const [prefix, label] of REASON_WITH_DETAIL) {
    if (!raw.startsWith(prefix)) continue;
    const detail = raw.slice(prefix.length).trim();
    return detail ? `${label} · Motivo: ${detail}` : label;
  }
  // Eduardo 2026-10-06: los dos jugadores reportaron lo mismo y el resultado
  // se aplicó solo (el servidor lo corre a nombre del dueño, pero NO es una
  // captura suya).
  if (raw.startsWith("result_report:auto_aprobado:coincidian")) {
    return "Aprobado solo (los dos reportaron lo mismo)";
  }
  if (raw.startsWith("team_tie_resolved:")) {
    const score = raw.slice("team_tie_resolved:".length).trim();
    return score ? `Serie ${score}` : "Serie actualizada";
  }
  return REASON_LABELS[raw] ?? raw;
}
